import React, { useEffect, useState } from "react";
import CancelButton from "../../Components/Buttons/CancelButton";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import ModalComponent from "../../Components/Modal/Modal";
import FilterLevel from "../../Components/SearchTeacherFilter/CollapseFilterInvoice";

function QualificationLevelModal(props) {
    const { qualifications, levelItems, changeDescriptionLevel } = props;
    const [levels, setVETLevel] = useState([])
    const [selectedItems, setSelectedItems] = useState(levelItems);

    useEffect(() => {
        // get all level of VET
        let levels = []
        let levelPriorities = []
        qualifications.filter(item => item.type === 'vet').forEach((item => {
            const subQualifications = item.qualifications
            subQualifications.forEach(ele => {
                if (!levels.includes(ele.level) && ele.level?.length) {
                    levels.push(ele.level)
                    levelPriorities.push({
                        name: ele.level,
                        priority: ele.priority
                    })
                }
                else if (levels.includes(ele.level) && ele.level?.length && ele.priority) {
                    const itemIndex = levelPriorities.findIndex(item => item.name === ele.level)
                    levelPriorities = [
                        ...levelPriorities.slice(0, itemIndex),
                        {
                            name: ele.level,
                            priority: ele.priority
                        },
                        ...levelPriorities.slice(itemIndex + 1)
                    ]
                }
            })
        }))

        levels.sort((a, b) => {
            const priorityA = levelPriorities.find(item => item.name === a)?.priority || 0;
            const priorityB = levelPriorities.find(item => item.name === b)?.priority || 0;
            return priorityA - priorityB;
        })

        setVETLevel(levels)
    }, [])

    const handleClose = () => {
        props.showPopup(false);
    };

    const handleLevelChange = (e, qua, rootID = null) => {
        setSelectedItems(e.target.value);
      }
    
      const handleSave = () => {
        changeDescriptionLevel(selectedItems);
        props.showPopup(false);
      }

    return <>
        <ModalComponent
            show={true}
            onClose={handleClose}
            className="model-for-addform custom-for-addCanDeliver"
            header="Change Level"
        >
            {qualifications?.length && levels?.length && <FilterLevel
                qualificationList={qualifications}
                levels={levels}
                selectedItems={selectedItems}
                onChangeCategory={(e, qua, rootID) => handleLevelChange(e, qua, rootID)}
                showTwoColumns={true}
            />}

            <div className="row qualification-footer mt-5">
                <div className="col-md-6 buttons">
                    <CancelButton onClick={handleClose}>Cancel</CancelButton>
                </div>
                <div className="col-md-6 buttons">
                    <ConfirmButton onClick={handleSave}>Select</ConfirmButton>
                </div>
            </div>
        </ModalComponent>
    </>
}

export default QualificationLevelModal;